import { ApiClientRepository } from '../../domain/ports/ApiClientRepository';
import {
  ApiClient,
  ApiClientOptions,
  CreateApiClientData,
  CreateApiClientResult,
  ApiClientDetails,
} from '../../domain/models/ApiClient';

export class ApiClientService {
  constructor(private apiClientRepository: ApiClientRepository) {}

  async getAll(): Promise<ApiClient[]> {
    return this.apiClientRepository.getAll();
  }

  async getOne(id: string): Promise<ApiClientDetails> {
    return this.apiClientRepository.getOne(id);
  }

  async getOptions(): Promise<ApiClientOptions> {
    return this.apiClientRepository.getOptions();
  }

  async create(data: CreateApiClientData): Promise<CreateApiClientResult> {
    return this.apiClientRepository.create(data);
  }

  async revokeSecret(apiClientId: string, secretId: string): Promise<void> {
    return this.apiClientRepository.revokeSecret(apiClientId, secretId);
  }

  async revokeClient(id: string): Promise<void> {
    return this.apiClientRepository.revokeClient(id);
  }

  async suspendClient(id: string): Promise<void> {
    return this.apiClientRepository.suspendClient(id);
  }

  async activateClient(id: string): Promise<void> {
    return this.apiClientRepository.activateClient(id);
  }

  async rotateSecret(apiClientId: string, secretId: string): Promise<{ secret: string }> {
    return this.apiClientRepository.rotateSecret(apiClientId, secretId);
  }

  async deleteClient(id: string): Promise<void> {
    return this.apiClientRepository.deleteClient(id);
  }
}
